import React from 'react';
import { Button, ButtonProps } from 'antd';
import './OutlineButton.css';

/**
 * OutlineButton
 * A white-outlined button on a black/transparent background.
 * Used for secondary CTAs like "Sign In" on auth pages.
 */
export default function OutlineButton({ className, ...props }: ButtonProps) {
    return (
        <Button
            {...props}
            className={`outline-button ${className || ''}`}
        />
    );
}
